import React, {
    ReactNode, useEffect, useMemo, useRef,
} from "react";
import Confetti from "react-confetti";
import { useNavigate } from "react-router";
import useRouting from "../../contexts/Routing";

export default function ConfettiSides() {
    const confettiLeftRef = useRef<HTMLCanvasElement>(null);
    const confettiRightRef = useRef<HTMLCanvasElement>(null);

    return (
        <>
            <Confetti
                ref={confettiLeftRef}
                width={document.body.clientWidth}
                height={document.body.scrollHeight}
                initialVelocityY={10}
                initialVelocityX={15}
                numberOfPieces={600}
                recycle={false}
                confettiSource={{
                    /* eslint-disable id-length */
                    x: 0,
                    y: 0,
                    w: 0,
                    h: 0,
                    /* eslint-enable id-length */
                }}
            />
            <Confetti
                ref={confettiRightRef}
                width={document.body.clientWidth}
                height={document.body.scrollHeight}
                initialVelocityY={10}
                initialVelocityX={-15}
                numberOfPieces={600}
                recycle={false}
                confettiSource={{
                    /* eslint-disable id-length */
                    x: document.body.clientWidth,
                    y: 0,
                    w: 0,
                    h: 0,
                    /* eslint-enable id-length */
                }}
            />
        </>
    );
}

export function SuccessConfetti({
    timeout,
    children,
}: {
    timeout?: number;
    children?: ReactNode;
}) {
    const { url, isSuccess } = useMemo(() => {
        const current = new URL(window.location.href);
        return {
            url: current,
            isSuccess: current.searchParams.has("isSuccess"),
        };
    }, [window.location.href]);

    const navigate = useNavigate();

    useEffect(() => {
        if (isSuccess) {
            setTimeout(() => {
                url.searchParams.delete("isSuccess");
                navigate({
                    pathname: url.pathname,
                    search: url.searchParams.toString(),
                    hash: url.hash,
                });
            }, timeout);
        }
    }, [isSuccess]);

    return isSuccess ? (
        <>
            <ConfettiSides />
            {children}
        </>
    ) : null;
}

SuccessConfetti.defaultProps = {
    timeout: 1000,
    children: undefined,
};
